import React, { createContext, useState, useContext } from 'react';

// Crea il Context
const HelpContext = createContext();

export const useHelp = () => useContext(HelpContext);

// Provider del context
export const HelpProvider = ({ children }) => {
  const [moduleName, setModuleName] = useState('');
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  const openHelp = (module) => {
    setModuleName(module);
    setIsHelpOpen(true);
  };

  const closeHelp = () => {
    setIsHelpOpen(false);
  };

  return (
    <HelpContext.Provider value={{ openHelp, closeHelp, moduleName, isHelpOpen }}>
      {children}
    </HelpContext.Provider>
  );
};
